<template>
  <layout-pondlogs
    v-loading="loading"
    headerType="card"
    :subHeader="true"
    containerType="card"
    class="pond-feeding"
  >
    <template slot="title">{{ $t("PM_pond_feeding") }}</template>
    <layout-toolbar slot="header">
      <el-col :span="6" :md="6" :lg="5" :xl="4">
        <er-date-picker
          class="date-picker-schedule"
          :value="dateRange"
          type="daterange"
          size="mini"
          :clearable="false"
          clear-icon=" "
          range-separator="-"
          start-placeholder="Start date"
          end-placeholder="End date"
          :format="$commonUtils.DATE_OBJ_DATE_FORMAT_WITH_YEAR"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          popper-class="schedule-date-picker-popper"
          @input="handleDateChange"
          :unlink-panels="true"
          :editable="false"
        ></er-date-picker>
      </el-col>
    </layout-toolbar>

    <layout-toolbar justify="space-between" slot="sub-header">
      <layout-toolbar justify="start" align="start">
        <span class="pond-actions__label">{{ $t("Ponds_actions") }}</span>
        <er-select
          v-model="pondsToActOn"
          size="mini"
          value-key="_id"
          filterable
          :placeholder="selectInputPlaceHolderNames['ponds']"
          popper-class="select-templates__drop-down"
          class="select-templates"
        >
          <template
            v-for="(sched, pondId) in getPondInScheduleModeHavingRunningScheds"
          >
            <el-option
              :key="pondId"
              :label="(sched || { pond_name: 'no title' }).pond_name"
              :value="sched"
            ></el-option>
          </template>
        </er-select>

        <er-select
          v-model="selectedAction"
          size="mini"
          value-key="_id"
          :placeholder="selectInputPlaceHolderNames['actions']"
          popper-class="select-templates__drop-down"
          :disabled="!pondsToActOn"
          class="select-templates"
        >
          <el-option
            :disabled="
              (pondsToActOn || { status: 'No Status' }).status === 'RUNNING'
            "
            key="RUNNING"
            :label="actions['RUNNING']"
            value="RUNNING"
          ></el-option>
          <el-option
            :disabled="
              (pondsToActOn || { status: 'No Status' }).status === 'PAUSED'
            "
            key="PAUSED"
            :label="actions['PAUSED']"
            value="PAUSED"
          ></el-option>
          <el-option
            key="STOPPED"
            :label="actions['STOPPED']"
            value="STOPPED"
          ></el-option>
        </er-select>

        <er-button
          size="mini"
          btnType="submit"
          :showLabel="true"
          :showIcon="false"
          :disabled="isReadOnly || selectedAction === ''"
          @click="handleActionOnPonds"
          :loading="actionLoading"
        ></er-button>
      </layout-toolbar>
      <layout-toolbar justify="end" class="select__set">
        <p class="set-selection__label">{{ $t("PM_select_set") }}</p>
        <er-select
          :value="getSelectedFt"
          name="Please Select Templates"
          size="mini"
          value-key="_id"
          @change="handleChangeTemplate"
          :placeholder="selectInputPlaceHolderNames['templates']"
          popper-class="select-templates__drop-down"
          class="select-templates"
        >
          <el-option
            v-for="(template, id) in objFtIdFtDetails"
            :key="id"
            :label="template.name"
            :value="template"
          ></el-option>
        </er-select>
      </layout-toolbar>
    </layout-toolbar>
    <div slot="pondlogs-default-layout-main">
      <div shadow="never" v-if="doesScreenHasError !== ''">
        <center style="margin-bottom:10px;">
          <el-tag type="danger">{{ $t(doesScreenHasError) }}</el-tag>
        </center>
      </div>
      <div class="schedule-card" shadow="never" v-loading="loading" v-else>
        <feed-entry-table></feed-entry-table>
        <el-row
          type="flex"
          justify="space-between"
          class="schedule-card__footer"
        >
          <el-alert
            v-if="getPondTitlesOtherThanSchedMode.length > 0"
            type="info"
            :closable="false"
          >
            <i class="el-icon-info"></i>
            {{
              `${$t(
                "Comn_ponds_with_other_modes"
              )} ${getPondTitlesOtherThanSchedMode.join(",")}`
            }}
          </el-alert>

          <er-button
            @click="submitScheduleDetails"
            btnType="save"
            size="mini"
            :showIcon="true"
            :showLabel="true"
            :disabled="isReadOnly"
          ></er-button>
        </el-row>
      </div>
    </div>
  </layout-pondlogs>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import feedEntryTable from "@/components/schedules/feedEntryTable";
import FeedTemplate from "@/model/feedtemplate";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
export default {
  props: ["tabData"],
  components: {
    feedEntryTable
  },
  mixins: [errorHandlerMixin],
  data: function() {
    return {
      ObjSchedulesTimeslots: {
        schedules: {},
        timeSlots: []
      },
      pondsToActOn: undefined,
      selectedAction: "",
      dateRange: ["", ""],
      loading: false,
      actionLoading: false,
      location: "",
      selectedTemplate: new FeedTemplate(),
      pondsInScheduleMode: [],
      pondsInRunningSchedule: [],
      pondAlreadyHavingSchedules: []
    };
  },
  computed: {
    ...mapGetters("pondFeeding", {
      getSelectedFt: "getSelectedFt",
      getFTIdToFTDetails: "getFTIdToFTDetails",
      getArrFeedTypes: "getArrFeedTypes",
      getPondTitlesOtherThanSchedMode: "getPondTitlesOtherThanSchedMode",
      getCurrDayExistSchedules: "getCurrDayExistSchedules",
      getPondIdToPondDetails: "getPondIdToPondDetails",
      getIsFTAvailable: "getIsFTAvailable",
      getPondsInScheduleMode: "getPondsInScheduleMode",
      noPondSelected: "noPondSelected",
      getPondIdsSelected: "getPondIdsSelected",
      getIsPondHasRunningScheds: "getIsPondHasRunningScheds",
      getCountOfValidTimeslotsForPond: "getCountOfValidTimeslotsForPond",
      getPondInScheduleModeHavingRunningScheds:
        "getPondInScheduleModeHavingRunningScheds"
    }),
    ...mapGetters("user", {
      isReadOnly: "isReadOnly",
      getCurrUserLocation: "getCurrUserLocation",
      getUserTimeZoneOffset: "getUserTimeZoneOffset"
    }),
    getLocationId() {
      return this.getCurrUserLocation._id;
    },
    objFtIdFtDetails: function() {
      return this.getFTIdToFTDetails;
    },
    getPondTitle: function() {
      return pondId => {
        return (this.getPondIdToPondDetails[pondId] || { title: "No Tile" })
          .title;
      };
    },
    getPondsLength: function() {
      return Object.values(this.getPondIdToPondDetails || {}).length;
    },
    getPondsInScheduleModeLength: function() {
      return Object.keys(this.getPondsInScheduleMode || {}).length;
    },
    doesScreenHasError: function() {
      if (this.getPondsLength === 0) {
        return "Comn_culture_not_started_msg";
      }
      if (this.getPondsInScheduleModeLength === 0) {
        return "PM_no_pond_sch_mode";
      }
      if (!this.getIsFTAvailable) {
        return "PM_no_sets_found";
      }
      return "";
    },
    mapPondIdSchedules() {
      return this.getMapPondIdSchedules;
    },
    getFeedTypes() {
      return this.getArrFeedTypes;
    },
    getSchedulesOfPonds() {
      return Object.values(this.ObjSchedulesTimeslots.schedules);
    },
    selectInputPlaceHolderNames() {
      return {
        ponds: this.$t("Ponds_select_ponds"),
        templates: this.$t("PM_select_set"),
        actions: this.$t("select_action")
      };
    },
    actions() {
      return {
        RUNNING: this.$t("PM_play"),
        PAUSED: this.$t("PM_pause"),
        STOPPED: this.$t("PM_stop")
      };
    },
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "Next Week",
            onClick: picker => {
              const start = this.$moment()
                .add(1, "days")
                .toDate();
              const end = this.$moment()
                .add(7, "days")
                .toDate();

              picker.$emit("pick", [start, end]);
            }
          }
        ],
        disabledDate: this.handleDisabledDate
      };
    }
  },

  async mounted() {
    this.initDateRange();
    this.initComponent();
  },
  methods: {
    ...mapActions("pondFeeding", {
      fetchAllPondDetails: "fetchAllPondDetails",
      fetchAllFeedTypes: "fetchAllFeedTypes",
      fetchAllFeedTemplates: "fetchAllFeedTemplates",
      changeDateRange: "changeDateRange",
      initFTTableData: "initFTTableData",
      changeSelectedFT: "changeSelectedFT",
      fetchAllPondMothers: "fetchAllPondMothers",
      savePondSchedules: "savePondSchedules",
      initPondIdToKGDT: "initPondIdToKGDT",
      fetchAllSchedDetails: "fetchAllSchedDetails",
      initUserTimeZoneOffset: "initUserTimeZoneOffset",
      changeStatusPondSched: "changeStatusPondSched",
      changeDateQueryType: "changeDateQueryType"
    }),
    ...mapMutations("pondFeeding", {
      VALIDATE_TS_FOR_ALL_SELECTED_PONDS: "VALIDATE_TS_FOR_ALL_SELECTED_PONDS"
    }),
    handleDisabledDate(time) {
      const timeObj = this.$moment(time);
      return !timeObj.isBetween(
        this.$moment().subtract(1, "days"),
        this.$moment().add(7, "days")
      );
    },
    getValidDateQueryType(date1, date2, format) {
      const today = this.$moment()
        .utcOffset(this.getUserTimeZoneOffset)
        .startOf("day");
      const momentDate1 = this.$moment(date1, format);
      const momentDate2 = this.$moment(date2, format);
      if (
        momentDate1.isBefore(today, "day") &&
        momentDate2.isBefore(today, "day")
      ) {
        return "PAST";
      } else if (
        momentDate1.isAfter(today, "day") &&
        momentDate2.isAfter(today, "day")
      ) {
        return "FUTURE";
      } else if (
        momentDate2.isSame(today, "day") &&
        momentDate1.isSame(today, "day")
      ) {
        return "TODAY";
      } else {
        throw {
          type: "FAIL_TO_SAVE",
          errors: [
            {
              message: this.$t("PM_dont_sel_current_date")
            }
          ]
        };
      }
    },
    handleClose() {
      this.unhandledErrorMessage = "";
    },
    async initDateRange() {
      const initDate = this.$moment()
        .utcOffset(this.getUserTimeZoneOffset)
        .add(0, "days")
        .format("YYYY-MM-DD");
      const initEndDate = this.$moment()
        .utcOffset(this.getUserTimeZoneOffset)
        .add(0, "days")
        .format("YYYY-MM-DD");
      this.dateRange = [initDate, initEndDate];
      const dateRangeQueryType = "TODAY";
      this.changeDateQueryType(dateRangeQueryType);
      await this.changeDateRange(this.dateRange);
    },
    initComponent: async function() {
      this.loading = true;
      try {
        await Promise.all([
          this.fetchAllPondMothers(),
          this.fetchAllPondDetails(),
          this.fetchAllFeedTemplates(),
          this.fetchAllFeedTypes()
        ]);
        await this.initUserTimeZoneOffset();
        await this.initPondIdToKGDT();
        // this.getFeedTemplates();
        if (this.getIsFTAvailable) {
          await this.handleChangeTemplate(
            Object.values(this.getFTIdToFTDetails)[0]
          );
        }
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    async handleChangeTemplate(value) {
      await this.changeSelectedFT(value);
      await this.initFTTableData();
      // handle if the pond in the template already has a schedule
    },
    async handleDateChange(value) {
      try {
        this.loading = true;
        const dateRangeQueryType = this.getValidDateQueryType(
          ...value,
          "YYYY-MM-DD"
        );
        this.dateRange = value;
        this.changeDateQueryType(dateRangeQueryType);
        await this.changeDateRange(value);
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    async handleActionOnPonds(value) {
      try {
        this.isEditable(this.tabData);
        this.actionLoading = true;
        await this.changeStatusPondSched({
          sched: this.pondsToActOn,
          status: this.selectedAction
        });
        this.$notify({
          title: this.$t("Usrs_success_msg"),
          message: this.$t("PM_sch_updated_success"),
          duration: 5000,
          type: "success"
        });
        this.pondsToActOn = undefined;
        this.selectedAction = "";
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.actionLoading = false;
      }
    },
    async checkWhetherToSaveTheSchedules() {
      await this.$confirm(
        this.$t("Comn_sch_upd_all_future_scheds"),
        this.$t("Comn_delete"),
        {
          confirmButtonText: this.$t("Comn_save"),
          cancelButtonText: this.$t("Comn_cancel"),
          type: "warning"
        }
      );
    },
    async submitScheduleDetails() {
      // let payloadSchedules = []
      try {
        this.isEditable(this.tabData);
        if (this.noPondSelected) {
          throw {
            type: "store",
            errors: [{ message: this.$t("Comn_select_atleast_pond") }]
          };
        }
        const errors = [];
        this.getPondIdsSelected.forEach(pondId => {
          const hasRunningSchedule = this.getIsPondHasRunningScheds(pondId);
          if (!hasRunningSchedule) return;
          const countOfValidSchedules = this.getCountOfValidTimeslotsForPond(
            pondId
          );
          if (countOfValidSchedules === 0) {
            errors.push({
              type: "schedule_count",
              pond_title: this.getPondTitle(pondId)
            });
          }
        });
        if (errors.length > 0) {
          throw {
            type: "FAIL_SAVE",
            errors
          };
        }
        this.VALIDATE_TS_FOR_ALL_SELECTED_PONDS();
        await this.checkWhetherToSaveTheSchedules();
        this.loading = true;
        await this.savePondSchedules();
        this.$notify({
          title: this.$t("Usrs_success_msg"),
          message: this.$t("PM_sch_updated_success"),
          duration: 5000,
          type: "success"
        });
      } catch (err) {
        if (err === "cancel") {
        } else if (err && err.type === "store") {
          this.errorFailToSave(err.errors);
        } else if (err && err.type === "FAIL_SAVE") {
          const errorArrString = err.errors.map(errInSched => {
            const inPondString = `${this.$t("Comn_in")} ${
              errInSched.pond_title
            }`;
            switch (errInSched.type) {
              case "timeslot_feed":
                return `${this.$t(errInSched.message)} ${this.$t(
                  "Comn_in"
                )} ${this.$t("Comn_schedule")} ${
                  errInSched.time_slot_id
                } ${this.$t("of")} ${errInSched.pond_title}`;
              case "schedule_count":
                return this.$t("no_timeslots_availble_for_pond", {
                  pond: errInSched.pond_title
                });
              case "feed":
                return `${this.$t(errInSched.message, {
                  threshold: 0.1
                })} ${inPondString}`;
              default:
                return `${this.$t(errInSched.message)} ${inPondString}`;
            }
          });

          const errors = errorArrString.map(x => ({ message: x }));
          this.errorFailToSave(errors);
        } else {
          this.errorMessages(err, true);
        }
      } finally {
        this.loading = false;
      }
    },
    error422Handler: function(err) {
      let errors = [];
      if (err.response.data.errors != null) {
        err.response.data.errors.details.forEach((error, index) => {
          if (error.errors != null) {
            error.errors.forEach((nestedErr, index) => {
              errors.push({ message: nestedErr.message });
            });
          } else {
            errors.push({ message: error.message });
          }
        });
      } else {
        errors = [{ message: err.response.data.message }];
      }
      this.errorFailToSave(errors);
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/mixins.scss";
$font-color: white;
.pond-feeding-error-lists {
  padding-left: 15px;
  max-height: 300px;
  overflow-y: auto;
}
.select__set {
  @include responsiveProperty(
    font-size,
    $app_font_size_small,
    $app_font_size_1,
    $app_font_size_2
  );
  display: flex;
  align-items: center;
  justify-content: center;

  .select-templates__drop-down {
    .el-select-dropdown__item span {
      width: 11em;
      display: block;
      position: relative;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    &.is-multiple .el-select-dropdown__item.selected::after {
      top: 0px;
    }
  }
}
.schedule-date-picker-popper {
  .el-picker-panel__sidebar {
    left: 0;
  }
  .el-picker-panel__body {
    margin-right: 0px;
    margin-left: 110px;
  }
}
.pond-feeding {
  &.pondlogs-default-layout {
    overflow-x: hidden;
    padding: 0px;
    .card-layout .el-card__body {
      padding: unset;
      // background-color: #66b3ff;
      // color: $font-color;
    }
  }

  .pond-actions__label {
    @include responsiveProperty(font-size, 1rem, 1rem, 0.8rem);
    text-align: left;
  }
  .set-selection__label {
    text-align: right;
  }

  .selectors-items--left,
  .selectors-items--right {
    display: flex;
    flex-direction: row;
    margin-left: 10px;
  }
  .selectors-items--right {
    line-height: 1;
    div[class^="selectors-items-"] {
      line-height: 2.3;
    }
  }
  .toolbar-layout {
    .select-templates {
      width: 180px;
      .el-input {
        @include small-text;
        .el-input__inner {
          text-transform: capitalize;
        }
      }
    }
  }
  .controls--button {
    margin: 10px;
    text-align: center;
  }
  .selectors-items {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .schedule-card__footer {
    margin: 5px 5px;
    .el-alert {
      width: unset;
      display: inline-flex;
      padding: 5px 10px;
      .el-alert__description {
        margin: unset;
      }
    }
  }
}
</style>
